module.exports = ".error-text {\r\n  color: red;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n}\r\n.selected-row {\r\n  background-color: #ffca28 !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/gis360/popup/renew-gis360-license/renew-gis360-license.component.css
// module id = 981
// module chunks = 1